import React, { useEffect, useState } from 'react';
import { X, BookOpen } from 'lucide-react';
const NAMES = ['Valeria', 'Romina', 'Sebastián', 'Marcela', 'Laura', 'Gabriela', 'Diego', 'Florencia', 'Martín', 'Claudia', 'Pablo', 'Natalia', 'Hernán', 'Verónica', 'Lucía'];
const CITIES = ['Córdoba', 'Buenos Aires', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca', 'Posadas', 'Resistencia', 'San Juan', 'Paraná'];
export function PopupNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [person, setPerson] = useState({
    name: '',
    city: ''
  });
  const getRandomPerson = () => {
    const name = NAMES[Math.floor(Math.random() * NAMES.length)];
    const city = CITIES[Math.floor(Math.random() * CITIES.length)];
    return {
      name,
      city
    };
  };
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      setPerson(getRandomPerson());
      setIsVisible(true);
    }, 3000);
    // Loop
    const interval = setInterval(() => {
      setPerson(getRandomPerson());
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    }, 25000); // Every 25 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 max-w-sm w-full animate-slide-in" data-id="element-1">
      <div className="bg-white border-l-4 border-[#16a34a] shadow-xl rounded-r-lg p-4 flex items-start gap-3 relative" data-id="element-2">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-3">
          <X size={16} data-id="element-4" />
        </button>

        <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-5">
          <BookOpen className="text-[#16a34a]" size={20} data-id="element-6" />
        </div>

        <div data-id="element-7">
          <p className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-1" data-id="element-8">
            Alguien acaba de comprar
          </p>
          <p className="text-sm font-semibold text-gray-900" data-id="element-9">
            Salud y Adolescencia 360
          </p>
          <p className="text-xs text-gray-600 mt-1" data-id="element-10">
            {person.name} de {person.city}
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-11">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}